module.exports = __webpack_public_path__ + "00fa52fe70deace7b2c75a91caa9cb5f.mp3";